export default __webpack_public_path__ + "./img/img_failure.jpg";